import type { Query, QueryMeta } from '@tanstack/react-query';

export interface ProjectListingsQueryMeta extends QueryMeta {
  readonly kind: 'project-listings';
  readonly stageFilter: string[] | undefined;
}

export const buildProjectListingsQueryMeta = (
  stageFilter: string[] | undefined,
): ProjectListingsQueryMeta => ({
  kind: 'project-listings',
  stageFilter,
});

export const readProjectListingsQueryMeta = (
  query: Query,
): ProjectListingsQueryMeta | undefined => {
  const meta = query.meta;
  if (!meta || (meta as { kind?: unknown }).kind !== 'project-listings') {
    return undefined;
  }
  return meta as ProjectListingsQueryMeta;
};
